import React, { useContext, useState, useEffect, useRef } from "react";
import { environment } from "../../environment";
import api from "../../services/api";
import { format, parseISO, set } from "date-fns";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Text,
  Button,
  Link,
  Input,
  Stack,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
  Select,
  useToast,
  Textarea,
  useDisclosure,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Checkbox,
  IconButton,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { OrderContext } from "../../contexts/Order";
import { ProlabContext } from "../../contexts/Prolab";
import { useParams } from "react-router-dom";
import JoditEditor from "../../components/Editor";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
export default function SendOrder() {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formStep, setFormStep] = useState(1);
  const { getOrderSendsApi, getOrderInfo, listTypesServiceApi, getOrderDocumentsApi, sendOrderApi, updateSendOrderApi} = useContext(OrderContext);
  const { listDocumentsApi } = useContext(ProlabContext);
  const { id } = useParams();
  const [orderSends, setOrderSends] = useState([]);
  const [orderDetails, setOrderDetails] = useState();
  const [formSend, setFormSend] = useState(true);
  const [newSend, setNewSend] = useState(false);
  const [send, setSend] = useState(false);
  const [rascunho, setRascunho] = useState(false);
  const [planID, setPlanID] = useState();
  const [planName, setPlanName] = useState();
  const [title, setTitle] = useState();
  const [typeService, setTypeService] = useState();
  const [recipientEmails, setRecipientEmails] = useState([]);
  const [recipientEmailTest, setRecipientEmailTest] = useState([]);
  const [subject, setSubject] = useState();
  const [body, setBody] = useState();
  const defaultSignature = `Um abração\nEquipe Provatis\n\n`;
  const [signature, setSignature] = useState(defaultSignature);
  const [listTypesService, setListTypesService] = useState([]);
  const [docs, setDocs] = useState([]);
  const [files, setFiles] = useState([]);
  const [attachmentPaths, setAttachmentPaths] = useState([]);
  const [clientID, setClientID] = useState();
  const userInfo  = JSON.parse(localStorage.getItem("user"));
  const fileInputRef = useRef(null);
  const [sendDetails, setSendDetails] = useState();
  const subjectDefault = `Seu artigo chegou! [Serviço] - [Plano] [Título]`;
  const [errors, setErrors] = useState({});
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const allowedExtensions = [
    "pdf", "doc", "docx", "dotx", "dot", "rtf", "txt", "xlsx", "xls",
    "csv", "ppt", "pptx", "ppsx"
  ];
  const [editNameDoc, setEditNameDoc] = useState(false);
  const [editedFileNames, setEditedFileNames] = useState({});
  const [editingFiles, setEditingFiles] = useState({});

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...recipientEmails];
    updatedEmails[index] = value;
    setRecipientEmails(updatedEmails);
  };

  const handleAddEmail = () => {
    setRecipientEmails([...recipientEmails, ""]);
  };

  const handleRemoveEmail = (index) => {
    const updatedEmails = recipientEmails.filter((_, i) => i !== index);
    setRecipientEmails(updatedEmails);
  };

  const validateEmails = () => {
    const errors = {
      recipientEmails: false,
      recipientEmailFormat: false,
    };
  
    const nonEmptyEmails = recipientEmails.filter(email => email.trim() !== "");
    if (nonEmptyEmails.length !== recipientEmails.length) {
      setRecipientEmails(nonEmptyEmails.length > 0 ? nonEmptyEmails : [""]);
    }
    if (nonEmptyEmails.length === 0) {
      errors.recipientEmails = true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const hasInvalidEmail = nonEmptyEmails.some(email => !emailRegex.test(email));
      
      if (hasInvalidEmail) {
        errors.recipientEmailFormat = true;
      }
    }
  
    return errors;
  };
  
  const toggleDocumentSelection = (doc) => {
    let fullPath = "";
    if(!doc.doc_category_id){
      if (!doc.type) {
        fullPath = `uploads/clients/${doc.filename}`;
      } else {
        fullPath = doc.filename.startsWith("uploads/expert/")
          ? doc.filename
          : `uploads/expert/${doc.filename}`;
      }
    } else if(doc.doc_category_id == 5) {
      fullPath = `uploads/documents/${doc.file_path}`;
    }
  
    setSelectedDocs((prevSelected) => {
      if (prevSelected.includes(fullPath)) {
        return prevSelected.filter((path) => path !== fullPath);
      } else {
        return [...prevSelected, fullPath];
      }
    });
  };
  
  const getBodyDefault = (planID, typeServiceID) => {
    if (planID == 1 && typeServiceID == 1) {
      return `Prezado [Nome do cliente],<br>

      Sua tradução (PT ➡️ Inglês científico) está pronta! 🌟<br>
  
      1. Em anexo, você encontrará os seguintes arquivos:<br>
      "CleanCopy": o seu artigo final, traduzido e impecável.<br><br>
  
      2. Rodada de correção ✍️📚<br>
      No Plano Basic, não realizamos rodadas de correção, e o nosso serviço se encerra. Esteja ciente de que não nos responsabilizamos por alterações no paper após a entrega do serviço.<br>
  
      3. Sua satisfação 😄<br>
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br>
  
      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>  
      Estamos à disposição para qualquer dúvida ou feedback adicional.`;
    }
  
    if (planID == 1 && typeServiceID == 2) {
      return `Caro [Nome do cliente],<br>

      Sua revisão (Inglês científico) está pronta! 🌟<br>
       
      1. Em anexo, você encontrará os seguintes arquivos:<br>
      "CleanCopy": o seu artigo final, revisado e impecável.<br>
      "Comparação": contém todas as mudanças realizadas por nossos Experts Provatis.* <br>
      *O arquivo Comparação é apenas para consulta.<br>
      
      2. Rodada de correção ✍️📚<br>
      No Plano Basic, não realizamos rodadas de correção, e o nosso serviço se encerra aqui. Esteja ciente de que não nos responsabilizamos por alterações no paper após a entrega do serviço.<br>
      
      3. Sua satisfação 😄<br>
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br>

      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>
      Estamos à disposição para qualquer dúvida ou feedback adicional. `;
    }
  
    if (planID == 2 && typeServiceID == 1) {
      return `Caro [Nome do cliente],<br>

      Sua tradução (PT ➡️ Inglês científico) está pronta! 🚀<br>
      
      1. Em anexo, você encontrará os seguintes arquivos:<br>
      Seu artigo científico:<br>
      "CleanCopy": o seu artigo final, traduzido e impecável.<br>
      “Manual - Rodada de correção”: manual a ser seguido, caso necessite da rodada de correção. 
      
      2. Sugestões de melhoria ✅<br>
      Deixamos sugestões de melhoria no texto como se fossemos revisores da revista, e elas podem ser (ou não) acatadas por você. Solicitamos fortemente a leitura de todos, pois alguns podem conter perguntas ou indicações de modificação.<br>
      
      3. Próximos passos ✍️📚<br>
      Você tem direito a uma rodada de correção do artigo gratuitamente!<br> 
      Nessa etapa, você pode reenviar o paper para correções pontuais e ele será reenviado em até 7 dias.<br>
      Essa rodada é opcional e deve ser solicitada em até 15 dias a partir do primeiro envio pela Provatis (consultar obrigatoriamente o manual para conferir a necessidade da rodada de correção* e prazos**).<br>
      *As sua revisão + correções devem ser feitas exclusivamente no arquivo CleanCopy.<br>
      **Não nos responsabilizamos por alterações no paper após o prazo para a rodada de correção.<br>
      
      
      
      4. Sua satisfação 😄<br>
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br>
      
      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>  
      Em caso de dúvidas ou feedback adicional, pode entrar em contato.`;
    }
    if (planID == 2 && typeServiceID == 2) {
      return `Sua revisão (Inglês científico) está pronta! 🚀<br> 

      1. Em anexo, você encontrará os seguintes arquivos:<br> 
      Seu artigo científico:<br> 
      "CleanCopy": o seu artigo final, revisado e impecável.<br> 
      "Comparação": contém todas as mudanças realizadas por nossos Experts Provatis.*<br> 
      *O arquivo Comparação é apenas para consulta.<br> 
      
      “Manual - Rodada de correção”: manual a ser seguido, caso necessite da rodada de correção.<br> 
      
      2. Sugestões de melhoria ✅<br> 
      Deixamos sugestões de melhoria no texto como se fossemos revisores da revista, e elas podem (ou não) ser acatadas por você. Solicitamos fortemente a leitura de todos, pois alguns podem conter perguntas ou indicações de modificação.<br> 
      
      3. Próximos passos ✍️📚<br> 
      Você tem direito a uma rodada de correção do artigo gratuitamente! <br> 
      Nessa etapa, você pode reenviar o paper para correções pontuais e ele será reenviado em até 7 dias. <br> 
      Essa rodada é opcional e deve ser solicitada em até 15 dias a partir do primeiro envio pela Provatis (consultar obrigatoriamente o manual para conferir a necessidade da rodada de correção* e prazos**).<br> 
      *As sua revisão + correções devem ser feitas exclusivamente no arquivo CleanCopy.<br> 
      **Não nos responsabilizamos por alterações no paper após o prazo para a rodada de correção. <br> 
      
      4. Sua satisfação 😄<br> 
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br> 
      
      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>  
      Em caso de dúvidas ou feedback adicional, pode entrar em contato.
      `;
    }
  
    if (planID == 3 && typeServiceID == 1) {
      return `Caro [Nome do cliente],<br>

      Sua tradução (PT ➡️ Inglês científico) está pronta! 🚀<br>
      
      1. Em anexo, você encontrará os seguintes arquivos:<br>
      Seu artigo científico:<br>
      "CleanCopy": o seu artigo final, traduzido e impecável.<br>
      “Manual - Rodada de correção”: manual a ser seguido, caso necessite da rodada de correção. <br>
      
      2. Sugestões de melhoria ✅<br>
      Deixamos sugestões de melhoria no texto como se fossemos revisores da revista, e elas podem (ou não) ser acatadas por você. Solicitamos fortemente a leitura de todos, pois alguns podem conter perguntas ou indicações de modificação.<br> 
      
      3. Próximos passos com a Provatis ✍️📚<br>
      Rodada de correção (opcional): <br>
      Você tem direito a uma rodada de correção do artigo gratuitamente! Nessa etapa, você pode reenviar o paper para correções pontuais. Em seguida, o paper será encaminhado diretamente para Edição de Normas e depois devolvido para você já todo finalizado.<br>
      Essa rodada é opcional e deve ser solicitada em até 15 dias a partir do envio pela Provatis (ver manual em anexo). Caso necessite, anexamos um manual que deve ser estritamente seguido como guia para as modificações que devem ser feitas exclusivamente no arquivo CleanCopy.<br>
      Edição nas normas da revista: <br>
      Acontece somente depois do artigo ser enviado novamente por você (independente da necessidade de rodada de correção). Lembrando que também necessitamos do arquivo “Dados para edição” completamente preenchido para darmos seguimento com a edição.<br> 
      
      4. Sua satisfação 😄<br>
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br>
      
      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>
      Em caso de dúvidas ou feedback adicional, pode entrar em contato.<br>`;
    }
    if (planID == 3 && typeServiceID == 2) {
      return `Caro [Nome do cliente],<br>

      Sua revisão (Inglês científico) está pronta! 🚀<br>
      
      1. Em anexo, você encontrará os seguintes arquivos::<br>
      Seu artigo científico:<br>
      "CleanCopy": o seu artigo final, revisado e impecável.<br>
      "Comparação": contém todas as mudanças realizadas por nossos Experts Provatis.* <br>
      *O arquivo Comparação é destinado apenas para sua consulta.<br>
      
      “Manual - Rodada de correção”: manual a ser seguido, caso necessite da rodada de correção. <br>
      
      2. Sugestões de melhoria ✅<br>
      Deixamos sugestões de melhoria no texto como se fossemos revisores da revista, e elas podem (ou não) ser acatadas por você. Solicitamos fortemente a leitura de todos, pois alguns podem conter perguntas ou indicações de modificação.<br>
      
      3. Próximos passos com a Provatis ✍️📚<br>
      Rodada de correção (opcional): <br>
      Você tem direito a uma rodada de correção do artigo gratuitamente! Nessa etapa, você pode reenviar o paper para correções pontuais. Em seguida, o paper será encaminhado diretamente para Edição de Normas e depois devolvido para você já todo finalizado. <br>
      Essa rodada é opcional e deve ser solicitada em até 15 dias a partir do envio pela Provatis (ver manual em anexo). Caso necessite, anexamos um manual que deve ser estritamente seguido como guia para as modificações que devem ser feitas exclusivamente no arquivo CleanCopy. <br>
      Edição nas normas da revista: <br>
      Acontece somente depois do artigo ser enviado novamente por você (independente da necessidade de rodada de correção). Lembrando que também necessitamos do arquivo “Dados para edição” completamente preenchido para darmos seguimento com a edição. <br>
      
      
      4. Sua satisfação 😄<br>
      Queremos melhorar o nosso trabalho entendendo o seu nível de satisfação com a Provatis. Leva somente 43 segundos do seu dia. É só clicar aqui.<br>
      
      Desejamos muito sucesso na publicação do seu paper e não se esqueça de compartilhar sua vitória conosco!<br>  
      Em caso de dúvidas ou feedback adicional, pode entrar em contato.`;
    }
  
    return "";
  };
  const nextStep = (step) => {
    let newErrors = {};
    const emailsValidate = validateEmails();
    newErrors = { ...newErrors, ...emailsValidate};
    if (!typeService) newErrors.typeService = true;
    if(!signature) newErrors.signature = true;
    if(selectedDocs.length === 0) newErrors.selectedDocs = true;
    if (Object.values(newErrors).some((val) => val === true)) {
      setErrors(newErrors);
      let message = "Por favor, preencha todos os campos.";
      if (newErrors.selectedDocs) {
        message = "Por favor, selecione pelo menos um documento.";
      }
      toast({
        title: message,
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
  
      return;
    }
    setFormStep(step);
  }
  const handleNewSend = () => {
    resetFormState();
  }
  const handleTypeService = (serviceName, serviceID) => {
    if (!subjectDefault || !orderDetails) return;
    
    const replacements = {
      "[Serviço]": serviceName,
      "[Plano]": orderDetails.details?.plan || 'Plano',
      "[Título]": orderDetails.details?.title || 'Artigo'
    };
  
    let customizedSubject = subjectDefault;
    for (const [key, value] of Object.entries(replacements)) {
      customizedSubject = customizedSubject.replace(key, value);
    }
  
    setSubject(customizedSubject);
    const bodyTexto = getBodyDefault(planID, serviceID).replace(
      "[Nome do cliente]",
      orderDetails.client.name
    );
    setBody(bodyTexto);
  };
  const handleViewDetails = (index) => {
    setPlanID(orderDetails.plan_id);
    setTitle(orderDetails.title);
    setRecipientEmails(index.recipient_emails);
    setSubject(index.subject);
    const signatureFinal = index.signature.replace(/<br\s*\/?>/g, '\n');
    setSignature(signatureFinal);
    setBody(index.body);
    setTypeService(index.type_service_id);
    setPlanName(orderDetails.details.plan);
    const processedAttachments = index.attachments_path?.map(attachment => {
      if (typeof attachment === 'object' && attachment.path && attachment.name) {
        return {
          path: attachment.path,
          name: attachment.name,
          originalName: attachment.path.split('/').pop()
        };
      }
      return {
        path: attachment,
        name: attachment.split('/').pop(),
        originalName: attachment.split('/').pop() 
      };
    }) || [];
    
    setSelectedDocs(processedAttachments.map(a => a.path));
    setEditedFileNames(processedAttachments.reduce((acc, attachment) => {
      if (attachment.name !== attachment.originalName) {
        acc[attachment.path] = attachment.name;
      }
      return acc;
    }, {}));
    setFormSend(true);
    setIsEditing(true);
    setFormStep(2);
  }
  const handleSendDetail =  async (index) => {
    setSendDetails(index);
    if(index.status == 0){
      setFormSend(true);
      setPlanID(orderDetails.plan_id);
      setTitle(orderDetails.title);
      setRecipientEmails(index.recipient_emails);
      setSubject(index.subject);
      const signatureFinal = index.signature.replace(/<br\s*\/?>/g, '\n');
      setSignature(signatureFinal);
      setBody(index.body);
      setTypeService(index.type_service_id);
      setPlanName(orderDetails.details.plan);
      const processedAttachments = index.attachments_path?.map(attachment => {
        if (typeof attachment === 'object' && attachment.path && attachment.name) {
          return {
            path: attachment.path,
            name: attachment.name,
            originalName: attachment.path.split('/').pop()
          };
        }
        return {
          path: attachment,
          name: attachment.split('/').pop(),
          originalName: attachment.split('/').pop()
        };
      }) || [];
      
      setSelectedDocs(processedAttachments.map(a => a.path));
      setEditedFileNames(processedAttachments.reduce((acc, attachment) => {
        if (attachment.name !== attachment.originalName) {
          acc[attachment.path] = attachment.name;
        }
        return acc;
      }, {}));
      setRascunho(true);
      setIsEditing(false);
      setFormStep(1);
    } else if(index.status == 2){
      setTypeService(index.type_service_id);
      setRecipientEmails(index.recipient_emails);
      setPlanID(orderDetails.plan_id);
      setTitle(orderDetails.title);
      setSubject(index.subject);
      setSignature(index.signature);
      setBody(index.body);
      setPlanName(orderDetails.details.plan);
      setAttachmentPaths(index.attachments_path);
      setSend(true);
    }
    
  };

   const handleDocumentSubmit = async () => {
    const orderID = localStorage.getItem("orderID");
    const token = localStorage.getItem("token");
    const formData = new FormData();
    const maxFiles = 15;
    const maxSizeFiles = 500 * 1024 * 1024;
    let totalSize = 0;
    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });

    formData.append("order_id", orderID);
    formData.append("user_id", clientID);
    for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
    }

    if (files.length < maxFiles) {
      if (totalSize < maxSizeFiles) {
        try {
          let invalidFiles = [];
          let newErrors = {};
          files.forEach((file) => {
          const extension = file.name.split(".").pop().toLowerCase();
          if (!allowedExtensions.includes(extension)) {
            invalidFiles.push(file.name);
          }
          });
      
          if (invalidFiles.length > 0) {
            setErrors({ ...newErrors, invalidFiles: true }); 
            toast({
              title: "Arquivo(s) com formato inválido.",
              description:` Os seguintes arquivos não foram aceitos: ${invalidFiles.join(", ")}`,
              status: "error",
              duration: 7000,
              isClosable: true,
            });
            return;
          }
          const response = await api.post(
            `orders/${orderID}/documents/client/upload-file`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );

          toast({
            title: "Upload feito com sucesso!",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setFiles([]);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }

          getDocumentsOrder();
        } catch (error) {
          setFiles([]);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          toast({
            title: "Não foi possível enviar o documento. Tente novamente.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } else {
        alert(`Você não pode enviar arquivos com mais de 500MB!`);
        setFiles([]);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } else {
      alert(`Você não pode enviar mais de ${maxFiles} arquivos!`);
      setFiles([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleFileNameChange = (fileId, newName) => {
    setEditedFileNames(prev => ({
      ...prev,
      [fileId]: newName
    }));
  };

  const truncateText = (text) => {
    if (text.length > 20) {
      return text.substring(0, 20) + "...";
    }
    return text;
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
  };
  async function salvarRascunho(){
    if(!sendDetails){
      createSendOrder(0);
    }else{
     updateSendOrder(0);
    }
  }
  const handleSend = async () => {
    if(rascunho == true){
      updateSendOrder(2);
    } else {
      createSendOrder(2);
    }
  }
  async function updateSendOrder(status){
    const signatureFinal = signature.replace(/\n/g, '<br>');
    let attachments_path;
    if (send == false) {
      attachments_path = selectedDocs.map(docPath => {
        const doc = docs.find(d => 
          docPath.includes(d.filename) || 
          docPath.includes(d.file_path)
        );
        return {
          path: docPath,
          name: editedFileNames[doc?.id] || doc?.filename || doc?.file_path.split('/').pop()
        };
      });
    } else {
      attachments_path = attachmentPaths.map(file => ({
        path: file.path,
        name: editedFileNames[file.id] || file.name
      }));
    }
    try {
      const data = {
        user_id: userInfo.id,
        type_service_id: typeService,
        subject: subject,
        recipient_emails: recipientEmails,
        body: body,
        signature : signatureFinal,
        attachments_path: attachments_path,
        status: status
      }
      await updateSendOrderApi(data, sendDetails.id);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }

  async function createSendOrder(status){
    const signatureFinal = signature.replace(/\n/g, '<br>');
    let attachments_path;
    if (send == false) {
      attachments_path = selectedDocs.map(docPath => {
        const doc = docs.find(d => 
          docPath.includes(d.filename) || 
          docPath.includes(d.file_path)
        );
        return {
          path: docPath,
          name: editedFileNames[doc?.id] || doc?.filename || doc?.file_path.split('/').pop()
        };
      });
    } else {
      attachments_path = attachmentPaths.map(file => ({
        path: file.path,
        name: editedFileNames[file.id] || file.name
      }));
    }
    const orderID = localStorage.getItem("orderID");
    let newErrors = {};
    if(subject ==='<p><br></p>' ) newErrors.subject = true;
    if(body ==='<p><br></p>') newErrors.body = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast({
        title: "Por favor, preencha todos os campos.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    const data = {
      user_id: userInfo.id,
      type_service_id: typeService,
      subject: subject,
      recipient_emails: status == 1 ? recipientEmailTest : recipientEmails,
      body: body,
      signature : signatureFinal,
      attachments_path: attachments_path,
      status: status
    }
    try {
      await sendOrderApi(data, orderID);
      if(status == 2){
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        toast({
          title: "Serviço Enviado",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }else if(status == 1){
        onClose();
        toast({
          title: "Teste Enviado",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }else{
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        toast({
          title: "Rascunho Salvo",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  async function getDocumentsOrder() {
    const orderID = localStorage.getItem("orderID");
    try {
      const response = await getOrderDocumentsApi(orderID);
      let allDocuments = [
        ...(response.data?.[1]?.client || []),
        ...(response.data?.[1]?.tradutor?.filter(
          (doc) => doc.version === "Clean Copy"
        ) || []),
        ...(response.data?.[1]?.revisor?.filter(
          (doc) => doc.version === "Clean Copy"
        ) || []),
        ...(response.data?.[1]?.editor?.filter(
          (doc) => doc.version === "Clean Copy"
        ) || []),
        ...(response.data?.[1]?.["edit-norms"]?.filter(
          (doc) => doc.version === "Clean Copy"
        ) || []),
        ...(response.data?.[1]?.feedback?.filter(
          (doc) => !doc.version || doc.version === "Clean Copy"
        ) || []),
      ];
      try {
        const manuaisResponse = await listDocumentsApi(5);
        const manuais = manuaisResponse.data?.[1] || [];
        const manuaisFormatados = manuais.map(manual => ({
            ...manual,
            file_path: manual.document_path,
            filename: manual.title
        }));
        
        allDocuments = [...allDocuments, ...manuaisFormatados];
      } catch (error) {
        console.log(error);
      }
      setDocs(allDocuments);
    } catch (error) {
      console.error(error);
    }
  }

  async function getTypesService() {
    try {
      const typesServices = await listTypesServiceApi();
      setListTypesService(typesServices.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }

  const typesServicesOptions = listTypesService.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  async function getOrderDetails() {
    const orderID = id;
    try {
      const orderInfoApi = await getOrderInfo(orderID);
      setOrderDetails(orderInfoApi.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }

  function resetFormState() {
    setPlanID(orderDetails?.plan_id);
    setTitle(orderDetails?.title);
    setRecipientEmails([orderDetails?.client.email || ""]);
    setClientID(orderDetails?.user_id);
    setPlanName(orderDetails.details.plan);
    setTypeService();
    setSubject();
    setBody();
    setSignature(defaultSignature);
    setSelectedDocs([]);
  }
  
  async function getOrderSends() {
    const orderID = id;
    try {
      const orderSendApi = await getOrderSendsApi(orderID);
      setOrderSends(orderSendApi.data?.[0]);
      console.log(orderSendApi.data?.[0] !== null);
      if (orderSendApi.data?.[0].length > 0 && newSend == false) {
        setFormSend(false);
      } else {
        resetFormState()
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getTypesService();
    getDocumentsOrder();
    getOrderDetails();
  }, []);
  
  useEffect(() => {
    if (orderDetails) {
      getOrderSends();
    }
  }, [orderDetails]);

  useEffect(() => {
    if (send == true) {
      createSendOrder(2);
    }
  }, [send]);

  return (
    <>
      {formSend == true ? (
        <Box
          bg={"#ffff"}
          borderRadius={"15px "}
          boxShadow={"0px 7px 16px 4px #EAEAEA"}
          p={5}
          ml={{
            base: 0, // Remove a margem em telas menores (base)
            md: "180px", // Define a margem em telas maiores (md)
          }}
          maxWidth={"100%"}
        >
          {(formStep === 2 && isEditing == false) && (
            <Button margin="2%" onClick={() => setFormStep(1)}>
              Voltar
            </Button>
          )}
         {(formStep === 2 && isEditing) && (
            <Button 
              margin="2%" 
              onClick={() => {
                setFormSend(0);
                setIsEditing(false);
              }}
            >
              Voltar
            </Button>
          )}
          {formStep === 1 && orderSends.length > 0 && (
            <Button margin="2%" onClick={() => setFormSend(0)}>
              Voltar
            </Button>
          )}
          <Text fontSize={"24px"} fontWeight={"600"} ml={"1rem"}>
            {formStep === 1 ? "Formulário de Enviar" : "E-mail de envio"}
          </Text>
          {formStep === 1 && (
            <Flex direction={{ base: "column", md: "row" }}  maxWidth="100%" overflow="hidden">
              <Box flex={{ base: "1", md: "1" }} marginLeft={{ base: "0", md: "1rem" }}>
                <FormControl>
                  <FormLabel fontSize={"18px"} marginTop={"5px"}>
                    Plano
                  </FormLabel>
                  <Text>{planName}</Text>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize={"18px"} marginTop={"20px"}>
                    Título do artigo
                  </FormLabel>
                  <Text>{title}</Text>
                </FormControl>
                <FormControl isInvalid={errors.typeService} isRequired>
                  <FormLabel fontSize={"18px"} marginTop={"20px"}>
                    Serviço
                  </FormLabel>
                  {listTypesService && (
                    <Select
                      value={typeService}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setTypeService(selectedValue);
                        const selectedOption = typesServicesOptions.find(
                          (opt) =>
                            opt.value.toString() === selectedValue.toString()
                        );
                        handleTypeService(
                          selectedOption?.label || "Serviço",
                          selectedValue
                        );
                      }}
                      placeholder="Selecione o Tipo de Serviço"
                    >
                      {typesServicesOptions.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </Select>
                  )}
                  <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                </FormControl>
                <FormControl
                  isInvalid={
                    errors.recipientEmails || errors.recipientEmailFormat
                  }
                  isRequired
                >
                  <FormLabel fontSize="18px" mt="20px">
                    Destinatário
                  </FormLabel>
                  <VStack spacing={2} align="stretch">
                    {recipientEmails.map((email, index) => (
                      <HStack key={index}>
                        <Input
                          type="email"
                          value={email}
                          onChange={(e) => handleEmailChange(index, e.target.value)}
                          placeholder={`Email ${index + 1}`}
                        />
                        {recipientEmails.length > 1 && (
                          <IconButton
                            aria-label="Remover email"
                            icon={<CloseIcon />}
                            size="sm"
                            colorScheme="red"
                            onClick={() => handleRemoveEmail(index)}
                          />
                        )}
                      </HStack>
                    ))}
                    <IconButton
                      aria-label="Adicionar email"
                      icon={<AddIcon />}
                      size="sm"
                      colorScheme="green"
                      alignSelf="flex-start"
                      onClick={handleAddEmail}
                    />
                  </VStack>
                  {errors.recipientEmails ? (
                    <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                  ) : errors.recipientEmailFormat ? (
                    <FormErrorMessage>
                      Insira um email válido (ex: exemplo@dominio.com).
                    </FormErrorMessage>
                  ) : null}
                </FormControl>
                <FormControl isInvalid={errors.signature} isRequired>
                  <FormLabel fontSize={"18px"} marginTop={"20px"}>
                    Assinatura
                  </FormLabel>
                  <Textarea
                    value={signature}
                    onChange={(e) => setSignature(e.target.value)}
                    minH="100px"
                    resize="vertical"
                    overflow="hidden"
                  />
                  <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                </FormControl>
              </Box>
              <Box
                flex={{ base: "1", md: "1" }} marginLeft={{ base: "0", md: "3rem" }}
              >
                <FormLabel fontSize={"18px"}>
                  Adicione os anexos para envio
                </FormLabel>
                <FormLabel fontWeight="bold">Cliente</FormLabel>
                <Text fontWeight={"light"}>Documentos: </Text>
                {docs
                .filter((doc) => !doc.type && !doc.doc_category_id)
                .map((doc) => {
                  const displayedName = editedFileNames[doc.id] || doc.filename;
                  
                  return (
                    <Box mt={2} fontSize={"14px"} key={doc.id}>
                      <Box display={"inline-flex"} alignItems="center">
                        <Checkbox
                          isChecked={selectedDocs.includes(
                            `uploads/clients/${doc.filename}`
                          )}
                          onChange={() => toggleDocumentSelection(doc)}
                          mr={2}
                        />
                        <Link
                          href={
                            environment.baseURL +
                            "/storage/uploads/clients/" +
                            doc.filename
                          }
                          target="_blank"
                        >
                          {truncateText(displayedName)}
                        </Link>
                        <FaEdit
                          cursor="pointer"
                          onClick={() => setEditingFiles(prev => ({
                            ...prev,
                            [doc.id]: !prev[doc.id]
                          }))}
                          style={{ 
                            color: "#38A169", 
                            fontSize: "20px", 
                            marginLeft: "8px" 
                          }}
                        />
                      </Box>
                      
                      {editingFiles[doc.id] && (
                        <Box mt={1}>
                          <Input 
                            value={editedFileNames[doc.id] !== undefined ? editedFileNames[doc.id] : doc.filename}
                            onChange={(e) => handleFileNameChange(doc.id, e.target.value)}
                            size="sm"
                            placeholder="Digite o novo nome"
                          />
                          <Button
                            marginTop="5px"
                            colorScheme="green"
                            fontSize="14px"
                            size="sm"
                            onClick={() => setEditingFiles(prev => ({
                              ...prev,
                              [doc.id]: false
                            }))}
                          >
                            Salvar
                          </Button>
                        </Box>
                      )}
                    </Box>
                  );
                })}
                {docs.filter((doc) => doc.type === 1 && doc.version === "Clean Copy").length > 0 && (
                <Box mt={4}>
                  <Text fontWeight="bold">Documentos Tradutor (Clean Copy)</Text>
                  {docs
                    .filter((doc) => doc.type === 1 && doc.version === "Clean Copy")
                    .map((doc) => {
                      const docPath = !doc.type 
                        ? `uploads/clients/${doc.filename}`
                        : doc.filename.startsWith("uploads/expert/")
                          ? doc.filename
                          : `uploads/expert/${doc.filename}`;
                      
                      return (
                        <Box mt={2} fontSize={"14px"} key={doc.id}>
                          <Box display={"inline-flex"} alignItems="center">
                            <Checkbox
                              isChecked={selectedDocs.includes(docPath)}
                              onChange={() => toggleDocumentSelection(doc)}
                              mr={2}
                            />
                            <Link
                              ml={2}
                              fontWeight={"bold"}
                              href={
                                doc.filename.startsWith("uploads/expert/")
                                  ? environment.baseURL + "/" + doc.filename
                                  : environment.baseURL + "/storage/uploads/expert/" + doc.filename
                              }
                              target="_blank"
                            >
                              {truncateText(editedFileNames[doc.id] || doc.filename)}
                            </Link>
                            <FaEdit
                              cursor="pointer"
                              onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: !prev[doc.id]}))}
                              style={{ color: "#38A169", fontSize: "20px", marginLeft: "8px" }}
                            />
                          </Box>
                          
                          {editingFiles[doc.id] && (
                            <Box mt={1}>
                              <Input 
                                value={editedFileNames[doc.id] !== undefined ? editedFileNames[doc.id] : doc.filename}
                                onChange={(e) => handleFileNameChange(doc.id, e.target.value)}
                                size="sm"
                                placeholder="Digite o novo nome"
                              />
                              <Button
                                marginTop="5px"
                                colorScheme="green"
                                fontSize="14px"
                                size="sm"
                                onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: false}))}
                              >
                                Salvar
                              </Button>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                </Box>
              )}
              {docs.filter((doc) => doc.type === 2 && doc.subtype != "Revisão PT" && doc.version === "Clean Copy").length > 0 && (
                <Box mt={4}>
                  <Text fontWeight="bold">Documentos Revisor (Clean Copy)</Text>
                  {docs
                    .filter((doc) => doc.type === 2 && doc.version === "Clean Copy")
                    .map((doc) => {
                      const docPath = !doc.type 
                        ? `uploads/clients/${doc.filename}`
                        : doc.filename.startsWith("uploads/expert/")
                          ? doc.filename
                          : `uploads/expert/${doc.filename}`;
                      
                      return (
                        <Box mt={2} fontSize={"14px"} key={doc.id}>
                          <Box display={"inline-flex"} alignItems="center">
                            <Checkbox
                              isChecked={selectedDocs.includes(docPath)}
                              onChange={() => toggleDocumentSelection(doc)}
                              mr={2}
                            />
                            <Link
                              ml={2}
                              fontWeight={"bold"}
                              href={
                                doc.filename.startsWith("uploads/expert/")
                                  ? environment.baseURL + "/" + doc.filename
                                  : environment.baseURL + "/storage/uploads/expert/" + doc.filename
                              }
                              target="_blank"
                            >
                              {truncateText(editedFileNames[doc.id] || doc.filename)}
                            </Link>
                            <FaEdit
                              cursor="pointer"
                              onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: !prev[doc.id]}))}
                              style={{ color: "#38A169", fontSize: "20px", marginLeft: "8px" }}
                            />
                          </Box>
                          
                          {editingFiles[doc.id] && (
                            <Box mt={1}>
                              <Input 
                                value={editedFileNames[doc.id] !== undefined ? editedFileNames[doc.id] : doc.filename}
                                onChange={(e) => handleFileNameChange(doc.id, e.target.value)}
                                size="sm"
                                placeholder="Digite o novo nome"
                              />
                              <Button
                                marginTop="5px"
                                colorScheme="green"
                                fontSize="14px"
                                size="sm"
                                onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: false}))}
                              >
                                Salvar
                              </Button>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                </Box>
              )}
              {docs.filter((doc) => doc.type === 3 && doc.version === "Clean Copy").length > 0 && (
                <Box mt={4}>
                  <Text fontWeight="bold">Documentos Editor (Clean Copy)</Text>
                  {docs
                    .filter((doc) => doc.type === 3 && doc.version === "Clean Copy")
                    .map((doc) => {
                      const docPath = !doc.type 
                        ? `uploads/clients/${doc.filename}`
                        : doc.filename.startsWith("uploads/expert/")
                          ? doc.filename
                          : `uploads/expert/${doc.filename}`;
                      
                      return (
                        <Box mt={2} fontSize={"14px"} key={doc.id}>
                          <Box display={"inline-flex"} alignItems="center">
                            <Checkbox
                              isChecked={selectedDocs.includes(docPath)}
                              onChange={() => toggleDocumentSelection(doc)}
                              mr={2}
                            />
                            <Link
                              ml={2}
                              fontWeight={"bold"}
                              href={
                                doc.filename.startsWith("uploads/expert/")
                                  ? environment.baseURL + "/" + doc.filename
                                  : environment.baseURL + "/storage/uploads/expert/" + doc.filename
                              }
                              target="_blank"
                            >
                              {truncateText(editedFileNames[doc.id] || doc.filename)}
                            </Link>
                            <FaEdit
                              cursor="pointer"
                              onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: !prev[doc.id]}))}
                              style={{ color: "#38A169", fontSize: "20px", marginLeft: "8px" }}
                            />
                          </Box>
                          
                          {editingFiles[doc.id] && (
                            <Box mt={1}>
                              <Input 
                                value={editedFileNames[doc.id] !== undefined ? editedFileNames[doc.id] : doc.filename}
                                onChange={(e) => handleFileNameChange(doc.id, e.target.value)}
                                size="sm"
                                placeholder="Digite o novo nome"
                              />
                              <Button
                                marginTop="5px"
                                colorScheme="green"
                                fontSize="14px"
                                size="sm"
                                onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: false}))}
                              >
                                Salvar
                              </Button>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                </Box>
              )}
              <Text fontWeight="bold">Manuais Cliente</Text>
              {docs
                .filter((doc) => doc.doc_category_id == 5)
                .map((doc) => (
                  <Box mt={2} fontSize={"14px"} key={doc.id}>
                    <Box display={"inline-flex"} alignItems="center">
                      <Checkbox
                        isChecked={selectedDocs.includes(`uploads/documents/${doc.file_path}`)}
                        onChange={() => toggleDocumentSelection(doc)}
                        mr={2}
                      />
                      <Link
                        href={environment.baseURL + "/storage/uploads/documents/" + doc.file_path}
                        target="_blank"
                      >
                        {truncateText(editedFileNames[doc.id] || doc.filename)}
                      </Link>
                      <FaEdit
                        cursor="pointer"
                        onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: !prev[doc.id]}))}
                        style={{ color: "#38A169", fontSize: "20px", marginLeft: "8px" }}
                      />
                    </Box>
                    
                    {editingFiles[doc.id] && (
                      <Box mt={1}>
                        <Input 
                          value={editedFileNames[doc.id] !== undefined ? editedFileNames[doc.id] : doc.filename}
                          onChange={(e) => handleFileNameChange(doc.id, e.target.value)}
                          size="sm"
                          placeholder="Digite o novo nome"
                        />
                        <Button
                          marginTop="5px"
                          colorScheme="green"
                          fontSize="14px"
                          size="sm"
                          onClick={() => setEditingFiles(prev => ({...prev, [doc.id]: false}))}
                        >
                          Salvar
                        </Button>
                      </Box>
                    )}
                  </Box>
                ))}

                <Box>
                  <Stack>
                    <Text>Adicionar Arquivos</Text>
                  </Stack>
                  <Box marginTop={"25px"}>
                    <FormControl isInvalid={errors.invalidFiles}>
                      <Input
                        pt={2}
                        fontSize="12px"
                        type="file"
                        accept=".pdf, .doc, .docx, .dotx, .dot, .rtf, .txt, .xlsx, .xls, .csv, .pptx, .ppt, .ppsx"
                        multiple
                        onChange={handleFileChange}
                      />
                     <FormErrorMessage>Tipos de arquivos permitidos: PDF, DOC, DOCX, DOTX, DOT, RTF, TXT, XLSX, XLS, CSV, PPTX, PPT, PPSX"
                     </FormErrorMessage>
                    </FormControl>
                  </Box>
                  <Box mt={5}>
                    <Button onClick={handleDocumentSubmit}>Enviar</Button>
                  </Box>
                </Box>
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={4} flexWrap="wrap" gap={2}>
                <Button
                  colorScheme="green"
                  marginTop={{ base: 0, md: "35rem" }}
                  onClick={() => nextStep(2)}
                  width={{ base: "100%", md: "auto" }}
                >
                  Próximo
                </Button>
              </Box>
            </Flex>
          )}{" "}
          {formStep === 2 && (
            <Flex
              direction="column"
              ml={"1rem"}
              mt={"1rem"}
              gap={4}
              overflow="hidden"
            >
              <FormControl isInvalid={errors.subject} isRequired>
                <FormLabel>Assunto</FormLabel>
                {isEditing == false ? (
                  <JoditEditor
                    onBlur={(newContent) => setSubject(newContent)}
                    value={subject}
                  />
                ) : (
                  <Text>{subject}</Text>
                )}
                <FormErrorMessage>Campo obrigatório</FormErrorMessage>
              </FormControl>
              <FormControl>
                <FormLabel>Corpo de Email</FormLabel>
                {isEditing == false ? (
                  <JoditEditor
                    onBlur={(newContent) => setBody(newContent)}
                    value={body}
                  />
                ) : (
                  <Box
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="lg"
                    p={4}
                    boxShadow="sm"
                    bg="white"
                  >
                    <div dangerouslySetInnerHTML={{ __html: body }} />
                  </Box>
                )}
              </FormControl>
              <FormControl>
                <FormLabel>Anexos</FormLabel>
                {isEditing === false ? (
                  docs && docs.length > 0 ? (
                    <Box p={2}>
                      {docs
                        .filter((doc) => {
                          let fullPath = "";

                          if (!doc.type && !doc.doc_category_id) {
                            fullPath = `uploads/clients/${doc.filename}`;
                          } 
                          else if (doc.doc_category_id) {
                              fullPath = `uploads/documents/${doc.file_path}`;
                          } 
                          else {
                              fullPath = doc.filename.startsWith("uploads/expert/")
                                  ? doc.filename
                                  : `uploads/expert/${doc.filename}`;
                          }

                          return selectedDocs.includes(fullPath);
                        })
                        .map((doc) => (
                          <Box
                            key={doc.id}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={2}
                            _last={{ mb: 0 }}
                          >
                            <Text fontSize="sm" isTruncated maxWidth="80%">
                            {truncateText(editedFileNames[doc.id] || doc.filename)}
                            </Text>
                          </Box>
                        ))}
                    </Box>
                  ) : (
                    <Text>Nenhum documento disponível</Text>
                  )
                ) : docs && docs.length > 0 ? (
                  <Box p={2}>
                    {docs
                      .filter((doc) => {
                        let fullPath = "";

                        if (!doc.type && !doc.doc_category_id) {
                          fullPath = `uploads/clients/${doc.filename}`;
                        } 
                        else if (doc.doc_category_id == 5) {
                            fullPath = `uploads/documents/${doc.file_path}`;
                        } 
                        else {
                            fullPath = doc.filename.startsWith("uploads/expert/")
                                ? doc.filename
                                : `uploads/expert/${doc.filename}`;
                        }

                        return selectedDocs.includes(fullPath);
                      })
                      .map((doc) => (
                        <Box
                          key={doc.id}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={2}
                          _last={{ mb: 0 }}
                        >
                          <Link
                            href={
                              doc.doc_category_id === 5
                                ? `${environment.baseURL}/storage/uploads/documents/${doc.file_path}`
                                : !doc.type && !doc.doc_category_id
                                ? `${environment.baseURL}/storage/uploads/clients/${doc.filename}`
                                : `${environment.baseURL}/storage/uploads/expert/${doc.filename}`
                            }
                            
                            passHref
                          >
                          {truncateText(editedFileNames[doc.id] || doc.filename)}
                          </Link>
                        </Box>
                      ))}
                  </Box>
                ) : (
                  <Text>Nenhum documento disponível</Text>
                )}
              </FormControl>
              {isEditing == false && (
              <Box marginRight={{ base: "0", md: "2rem" }}>
                <Stack 
                  direction={{ base: "column", md: "row" }}
                  spacing={{ base: 3, md: 4 }}
                  marginTop="1rem"
                >
                  <Button
                    colorScheme="green"
                    fontSize="14px"
                    onClick={() => handleSend()}
                    width={{ base: "100%", md: "auto" }}
                  >
                    Enviar Serviço
                  </Button>
                  <Button
                    colorScheme="green"
                    fontSize="14px"
                    onClick={onOpen}
                    width={{ base: "100%", md: "auto" }}
                  >
                    Enviar Teste
                  </Button>
                  <Button
                    colorScheme="green"
                    fontSize="14px"
                    onClick={salvarRascunho}
                    width={{ base: "100%", md: "auto" }}
                  >
                    Salvar Rascunho
                  </Button>
                </Stack>
              </Box>
            )}
            </Flex>
          )}
        </Box>
      ) : (
        <>
          <Box
            mt={5}
            bg={"#ffff"}
            borderRadius={"15px"}
            boxShadow={"0px 7px 16px 4px #EAEAEA"}
            p={5}
            ml={{
              base: 0,
              md: "180px",
            }}
            maxWidth={"100%"}
            overflowX="auto"
          >
            <Flex
              direction={{ base: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ base: "flex-start", md: "center" }}
              gap={4}
            >
              <Text margin={"2%"} fontSize="lg" fontWeight="bold">
                Histórico de Envios
              </Text>
              <Button
                colorScheme="green"
                fontSize={"14px"}
                onClick={() => {
                  setFormSend(true);
                  setFormStep(1);
                  setNewSend(true);
                  handleNewSend();
                }}
                alignSelf={{ base: "flex-end", md: "unset" }}
              >
                Fazer Novo Envio
              </Button>
            </Flex>
            <Table>
              <Thead>
                <Tr>
                  <Td>Data</Td>
                  <Td>Enviado Por</Td>
                  <Td>Enviado Para</Td>
                  <Td>Status</Td>
                </Tr>
              </Thead>
              <Tbody>
                {orderSends.length > 0
                  ? orderSends.map((index) => (
                      <Tr key={index.id}>
                        <Td>
                          {format(parseISO(index.created_at), "dd/MM/yyyy")}
                        </Td>
                        <Td>{index.user?.name}</Td>
                        <Td>
                          {Array.isArray(index.recipient_emails) ? (
                            index.recipient_emails.map((email, i) => (
                              <div key={i}>{email}</div>
                            ))
                          ) : (
                            index.recipient_emails
                          )}
                        </Td>
                        <Td>
                          {index.status === 0
                            ? "Rascunho"
                            : index.status === 1
                            ? "Envio Teste"
                            : index.status === 2
                            ? "Enviado"
                            : ""}
                        </Td>
                        <Td>
                          <Button
                            onClick={() => handleSendDetail(index)}
                            colorScheme="green"
                            fontSize={"12px"}
                          >
                            {index.status === 0
                              ? "Editar"
                              : index.status === 1
                              ? "Enviar para o cliente"
                              : index.status === 2
                              ? "Reenviar para o cliente"
                              : ""}
                          </Button>
                        </Td>
                        {index.status === 2 ? (
                           <Td px={1} width="1px"> 
                            <Box color={"green"}>
                              <MdRemoveRedEye
                                cursor={"pointer"}
                                onClick={() => handleViewDetails(index)}
                              />
                            </Box>
                          </Td>
                        ) : (
                          ""
                        )}
                      </Tr>
                    ))
                  : " "}
              </Tbody>
            </Table>
          </Box>
        </>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Envio Teste</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Email"
              onChange={(e) => setRecipientEmailTest([e.target.value])}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => createSendOrder(1)}
            >
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
